import { useSelector } from "react-redux";
import AppLayout from "./AppLayout";
import AppLayoutsPublic from "./AppLayoutsPublic";

/**
 * For routes that must stay reachable by anonymous visitors (so they can't
 * live under PrivateRoute) but are also a real in-app destination that
 * logged-in users land on constantly via internal links (search results,
 * comment/post usernames, followed-journalists, group member lists...).
 * Public profiles under bare AppLayoutsPublic left a logged-in viewer with
 * zero navigation at all -- no sidebar, no mobile bar, not even a Back
 * link -- confirmed live across every route in an audit.
 *
 * AppLayout itself has no auth-check baked in (that's PrivateRoute's job,
 * which this route intentionally isn't wrapped in) -- it's just chrome
 * around <Outlet/>, so it's safe to reuse directly here for the
 * authenticated case.
 */
const SemiPublicLayout = () => {
  const isAuthenticated = useSelector((state) => state.auth?.isAuthenticated);
  return isAuthenticated ? <AppLayout /> : <AppLayoutsPublic />;
};

export default SemiPublicLayout;
